(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('QuoteSplitModalService', QuoteSplitModalService);

    QuoteSplitModalService.$inject = ['$uibModal', '$state'];

    function QuoteSplitModalService ($uibModal, $state) {
        var service = {
            openCreateDialog: openCreateDialog
        };

        var modalInstance = null;

        var resetModal = function () {
            modalInstance = null;
            // $state.go("home");
        };

        return service;

        function openCreateDialog (quote, contact, options) {
            if (modalInstance !== null) return;

            var originatorQuoteSplit = quote.quoteSplits.find(function(qs) { return qs.role === "ORIGINATOR"; });
            var invoicingEnabled = (options && options.invoicingEnabled) || false;

            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/quote-split/quote-split-dialog.html',
                controller: 'QuoteSplitDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('quoteSplit');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            quoteId: quote.id,
                            totalAmount: quote.total,
                            originatorAmount: originatorQuoteSplit ? originatorQuoteSplit.splitAmount : 0.0,
                            clientContact: contact,
                            adjustmentReason: quote.adjustmentReason,
                            invoicingEnabled: invoicingEnabled
                        };
                    }
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );

            gtag("event", "modal_open", {title: "Quote Split Dialog"});

            return modalInstance;
        }

    }
})();
